<template>
  <div class="header-box search">
    <component :is="currentComponent" :supplierId="supplierId" @noSite="noSite"></component>
    <template v-if="isInitShowFixed">
      <div v-show="isShowFixed">
        <transition name="fade">
          <HeaderFixed :isFixed="true"></HeaderFixed>
        </transition>
      </div>
    </template>
  </div>
</template>
<script>
import HeaderMain from './header-main.vue'
import HeaderFixed from './header-fixed.vue'
import HeaderInfo from './header-info.vue'
import HeaderOther from './header-other.vue'
export default {
  components: {
    HeaderMain,
    HeaderFixed,
    HeaderInfo,
    HeaderOther
  },
  props: {
    supplierId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isInitShowFixed: false, // 第一次滑动
      isShowFixed: false,
      pathComponent: {
        HeaderMain: ['main', 'store', 'channel', 'list', 'store-shop'],
        HeaderInfo: ['info', 'supplier-shop'],
        HeaderOther: ['compare-price', 'cart', 'req', 'scene-list', 'scene-detail']
      }
    }
  },
  created () {
    //检测屏幕高度
    document.addEventListener('scroll', (e) => {
      let scrollTop = window.scrollY || document.body.scrollTop || document.documentElement.scrollTop || 0
      if (scrollTop > 320) {
        this.isInitShowFixed = true
        this.isShowFixed = true
      } else {
        this.isShowFixed = false
      }
    })
  },
  computed: {
    // 当前搜索样式
    currentComponent () {
      let pathName = this.$route.name
      for (let key in this.pathComponent) {
        if (this.pathComponent[key].includes(pathName)) {
          return key
        }
      }
      return 'HeaderMain'
    }
  },
  methods: {
    noSite () {
      this.$emit('noSite')
    }
  }
}
</script>

<style scoped lang="scss">
.header-box{
  // padding: 27px 0 12px 0;
  background-color: #fff;
  height: 100%;
}
</style>
